export default {
  layers: 'Couches',
  panzoom: {
    helpText: 'Raccourcis utiles :\n'
      + 'Ctrl + molette de la souris - zoom avant/arrière\n'
      + 'Clic gauche de la souris + glisser - déplacer la zone',
  },
  errors: {
    pointsRequired: 'Un point doit être ajouté',
  },
};
